(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('treatmentHistoryComponent', treatmentHistoryComponent);

    treatmentHistoryComponent.$inject = [];

    function treatmentHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveTreatmentHistoryController,
            templateUrl: 'app/npq-questionnaire/workflow/partial/directive/treatment-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveTreatmentHistoryController.$inject = ['$scope', '$stateParams', '$element', '$timeout'];
    function DirectiveTreatmentHistoryController($scope, $stateParams, $element, $timeout) {
        
        function init() {
            
        }

        init();
    }
})();
